import CustomMainVerify from '@comp/CustomVerify';
import CustomFailed from '@root/components/CustomFailed';
import CustomSuccess from '@root/components/CustomSuccess';
import { getTengebaiContentData } from '@root/constants/formData';
import {
  tengebaiVerify,
  tengebaiVerifyFailed,
  tengebaiVerifySuccess
} from '@root/constants/paths';

const { main } = getTengebaiContentData();

const formVerifyData = {
  title: 'tengebai_confirm_your_card'
};

export const getTengebaiVerifyRoutes = () => [
  {
    path: tengebaiVerify(),
    element: (
      <CustomMainVerify
        mainContent={main}
        formData={formVerifyData}
        redirectPaths={{
          success: tengebaiVerifySuccess,
          failed: tengebaiVerifyFailed
        }}
      />
    )
  },
  {
    path: tengebaiVerifySuccess(),
    element: <CustomSuccess />
  },
  {
    path: tengebaiVerifyFailed(),
    element: <CustomFailed />
  }
];
